
import { Component, Vue } from "vue-property-decorator";
import config from "./config";
import { LogHelper } from "@/common/LogHelper";
import { WeighbridgeBll } from "@/common/glboalconstant";
import dayjs from "dayjs";
import { lookUpBaseData } from "@/api/service";
import { SystemConfigModule } from "@/store/modules/store_systemconfig";

@Component({
  name: "Form3",
  components: {
  },
})
export default class extends Vue {
  public globalConfig: any = {};
  public loginData: any = {};
  mounted() {
    try {
      this.SetDefaultDateRange();
      this.globalConfig = SystemConfigModule.globalData;
      this.loginData = SystemConfigModule.loginData;
    } catch (error) {
      console.log("地磅称重3Vue出现异常:" + error);
    }
  }
  public currentRow = null;
  public handleCurrentChange(val) {
    this.currentRow = val;
  }
  public timeOptionRange: String = "";

  public pickerOptions = {
    onPick: (time) => {
      if (time.minDate && !time.maxDate) {
        this.timeOptionRange = time.minDate;
      }
      if (time.maxDate) {
        this.timeOptionRange = null;
      }
    },
    disabledDate: (time) => {
      let timeOptionRange: any = this.timeOptionRange;
      let secondNum = 6 * 60 * 60 * 24 * 1000;
      if (timeOptionRange) {
        return (
          time.getTime() > timeOptionRange.getTime() + secondNum ||
          time.getTime() < timeOptionRange.getTime() - secondNum
        );
      }
    },
  };
  public loading = false;
  public list = [];
  public option = [];
  public states = ["Alabama", "Alaska", "Arizona"];
  public remoteMethod(query) {
    if (query !== "") {
      this.loading = true;
      var result = this.QueryCP(query);
      var resultObj = JSON.parse(result);
      this.list = resultObj.CPList.map((item) => {
        return { value: `${item}`, label: `${item}` };
      });
      setTimeout(() => {
        this.loading = false;
        this.option = this.list.filter((item) => {
          return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
        });
      }, 200);
    } else {
      this.option = [];
    }
  }

  public QueryCP(CP) {
    try {
      let _list = [];

      let request = {
        devMac: this.globalConfig.LocalMac,
        devType: "0",
        body: {
          dbType: "1",
          columns: "VEHICLE_PLATE_NO",
          tableName: "t_exp_vehicle",
          condition: "VEHICLE_PLATE_NO like " + "'%" + CP + "%'",
          descs: "",
          ascs: "",
          current: "",
          size: "5",
        },
      };
      let response = JSON.parse(lookUpBaseData(JSON.stringify(request)));

      if (response.respcode != "000") {
        LogHelper.WriteLog("查询失败" + response.respMessage);
      } else {
        let jsData = response.data.busiData;
        let str = this.CleanString(JSON.stringify(jsData.records));
        let jArray = JSON.parse(str);

        jArray.forEach((item) => {
          let jdata = item;
          if (jdata.VEHICLE_PLATE_NO != null) {
            _list.push(jdata.VEHICLE_PLATE_NO.toString());
          }
        });
      }
      let queryCPResponse = { CPList: _list, query: CP };

      return JSON.stringify(queryCPResponse);
    } catch (ex) {
      LogHelper.WriteLog(ex.toString());
      return JSON.stringify({ CPList: [], query: CP });
    }
  }
  private CleanString(newStr) {
    let tempStr = newStr.replace("\n", "");
    tempStr = tempStr.replace("\r", "");
    return tempStr;
  }
  public alert(title, message) {
    if (title == null) {
      title = "错误信息";
    }
    this.$alert(message, title, {
      confirmButtonText: "确定",
      callback: null,
    });
  }
  private QueryWeightRecordFunc() {
    if (this.formmodel3.input_DateRange == null) {
      this.alert(null, "请先选择日期");
      return;
    }
    this.QueryWeightRecord(this.formmodel3);
  }
  public QueryWeightRecord(Object) {
    debugger;
    LogHelper.WriteLog("地磅称重列表查询开始：" + Object.input_CarLabel);
    Object.input_CarLabel = Object.input_CarLabel.toUpperCase();
    try {
      var dateStart = dayjs(Object.input_DateRange[0]).format(
        "YYYY-MM-DD 00:00:00"
      );
      var dateEnd = dayjs(Object.input_DateRange[1]).format(
        "YYYY-MM-DD 00:00:00"
      );
      Object.input_DateRange[0] = dateStart;
      Object.input_DateRange[1] = dateEnd;
      var request = this.GetWeightHistoryRequest(Object);
      debugger;
      let response = JSON.parse(
        obj_HttpRequest_Core.post(
          "/Yto_BusiGateway/client/loadometer/weightHistory",
          JSON.stringify(request)
        )
      );

      if (response == null || response.respcode != "000") {
        this.$message({
          message:
            "查询失败, 错误信息:" +
            response.respMessage +
            "，错误代码：" +
            response.respcode,
          type: "error",
        });
        return false;
      }

      let data = [];
      if (
        response.data != null &&
        response.data.length > 0 &&
        response.data != "null"
      ) {
        data = JSON.parse(response.data);
        data.forEach((t) => {
          t.ioStatusText = WeighbridgeBll.IoStatusList.filter(
            (item) => item.value == t.ioStatus
          )[0].key;
          t.statusText = t.status == "1" ? "已上传" : "未上传";
        });
      } else {
        data = [];
      }
      this.showPrintedList = data;
      LogHelper.WriteLog("地磅称重列表查询结束:" + Object.input_CarLabel);

      return true;
    } catch (ex) {
      LogHelper.WriteLog("地磅称重列表：" + ex);
      return false;
    }
  }
  private GetWeightHistoryRequest(Object) {
    return {
      devMac: this.globalConfig.LocalMac,
      devType: "0",
      body: {
        carNumber: Object.input_LicensePlateNumber,
        containerNo: Object.input_CarLabel,
        weighingTimeEnd: Object.input_DateRange[1], //"yyyy-MM-dd 00:00:00"
        weighingTimeStart: Object.input_DateRange[0],
      },
    };
  }
  private PrintRecordFunc() {
    if (this.currentRow == null) {
      this.alert(null, "请先选择要打印的行！");
      return;
    }
    this.PrintRecord(this.currentRow);
  }
  /// <summary>
  /// 打印
  /// </summary>
  public PrintRecord(Object) {
    try {
      debugger;
      obj_ScanForWeighbridge.printTicket("item", JSON.stringify(Object));
    } catch (ex) {
      LogHelper.WriteLog("打印失败:" + ex.toString());
      this.$message.error("打印失败, 错误信息:" + ex.Message);
    }
  }
  private SetDefaultDateRange() {
    this.formmodel3.input_DateRange = [];

    var _lastday = new Date();
    _lastday.setDate(_lastday.getDate() - 1);
    var _today = new Date();
    _today.setDate(_today.getDate());

    this.formmodel3.input_DateRange.push(_lastday);
    this.formmodel3.input_DateRange.push(_today);
  }

  public carlabel = "";
  private config = config;

  private formmodel3: inputDataModel_WeighbridgeList = {
    input_CarLabel: "",
    input_LicensePlateNumber: "",
    input_DateRange: [],
    checked_NeedVolumn: false,
    checked_NeedWeight: false,
  };
  public showPrintedList = [];

  public options = [
    {
      value: "",
      label: "",
    },
  ];
}
